<template>

    <el-dialog :title="tit" :visible="editFormVisible" :close-on-click-modal="false" :modal-append-to-body='false'
      :before-close="clearEditForm" width="30%">
      <el-form :model="editForm" ref="editForm" size="mini" class="edit_form" :rules="editFormRules">

        <el-form-item label="营运商" prop="operatorId" :label-width="formLabelWidth">
        <el-form-item prop="operatorId">
          <!--        <el-select placeholder="运营商" v-model="searchForm.operatorId" clearable>
          <el-option v-for="item in operatorForSelect" :key="item.id"
                     v-bind:label="item.name" v-bind:value="item.id"></el-option>
        </el-select>-->
          <el-cascader size="mini"  clearable ref="cascader" placeholder="运营商" filterable :options="listForSelectTree"
            :show-all-levels="false" :props="{ checkStrictly:true,expandTrigger:'hover'}" change-on-select
            @change='changeOpertorIds' v-model="editForm.operatorId">
          </el-cascader>
        </el-form-item>
        </el-form-item>
        <el-form-item prop="stationId" label="站点" :label-width="formLabelWidth">
          <el-select  v-model="editForm.stationId" size="mini" placeholder="请选择站点 "  @change="change()" clearable>
            <el-option v-for="item in stations" :key="item.id" :label="item.stationName" :value="item.id">
              {{item.stationName}}
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="百分比:" :label-width="formLabelWidth" prop="percentage">
          <el-input placeholder="请输入百分比"   v-model="editForm.percentage" class="input-with-select"  @input="update($event)"></el-input>
        </el-form-item>


      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="clearEditForm">取 消</el-button>
        <el-button size="small" type="primary" @click.native="editSubmit" :loading="editSubmitLoading">确 定</el-button>
      </div>
    </el-dialog>

</template>

<script>
  var isPrice = (rule, value, callback) => {
    var pattern = /[^\d.]/g
    if (!pattern.test(value)) {
      callback(new Error('只能输入数字和小数点'))
    } else return callback()
  }
  export default {
    name: "add",
    data() {
      return {
        editFormRules: {
          operatorId: [{
            required: true,
            message: '请选择所属运营商',
            trigger: 'blur'
          }],
          stationId: [{
            required: true,
            message: '请选择所属站',
            trigger: 'blur'
          }],

          percentage: [{
            required: true,
            message: '请输入百分比',
            trigger: 'blur'
          }]
        },
        formLabelWidth: '100px',
      }
    },
    props: {
      tit: '',
      editForm: {},
      stations: {},
      editFormVisible: false,
      listForSelectTree: {},
      editSubmitLoading: false,
    },
    methods: {
      clearEditForm() {
        let _this = this
        if (this.editForm.id == null || this.editForm == '') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        } else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit() {
        this.$emit("editSubmit", this.$refs.editForm)
      },
          update: function (e) {
            this.$forceUpdate()	// 刷新
          },
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      change() {

        this.$forceUpdate()
      },
      changes(e){
        this.$forceUpdate()
      },
      changeOpertorIds(value) {
        let operatorId = value && value.length > 0 ? value[value.length - 1] : ''
        console.log(value)
        this.editForm.operatorId = operatorId
        this.editForm.stationId = ''
        this.$forceUpdate()
        this.$refs.cascader.dropDownVisible = false
        this.$emit("changeOpertorIds")
      },

      handleChangeOperator(value) {
        let operatorId = value && value.length > 0 ? value[value.length - 1] : ''
        this.editForm.operatorId = operatorId

        this.$emit("operatorSelect", operatorId)
      },
      operatorSelect(val) {
        this.$emit("operatorSelect", val)
      },
      stationSelect(val) {
        this.$emit("stationSelect", val)
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
    .el-form-item__content {
      .el-input {
        width: 220px;
      }
    }
  }

  .timeLabOut {
    margin-top: 20px;
    user-select: none;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    border-top: 1px solid rgba(0, 0, 0, 0.2);
  }

  .timeLabIn {
    user-select: none;
    width: 100%;
    line-height: 40px;
  }

  .timeLabInCol {
    user-select: none;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  .topCheck {
    background-color: rgba(64, 158, 255, 0.6);
  }

  .summitCheck {
    background-color: rgba(103, 194, 58, 0.6);
  }

  .flatCheck {
    background-color: rgba(245, 108, 108, 0.6);
  }

  .valleyCheck {
    background-color: rgba(230, 162, 60, 0.6);
  }
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/stationPercentage/add.vue